export enum CarriageType {
  PreCarriage = 'PRE_CARRIAGE',
  MainCarriage = 'MAIN_CARRIAGE',
  OnCarriage = 'ON_CARRIAGE',
}
